
// * ========================================================================
// * dropdown
// * ========================================================================

const dropdown = (function(){
    /**
     * Initialize
     */
    function init() {
        const triggers = document.querySelectorAll('.dropdown-btn');

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', function (e) {
                this.closest('.dropdown').classList.toggle('open');
                e.stopPropagation();
            });
        });

        // Detect all clicks on the document
        document.addEventListener('click', function(event) {
            // If user clicks inside the element, do nothing
            if (event.target.closest('.dropdown-content')) return;

            // If user clicks outside the element, hide it!
            const dropdowns = document.querySelectorAll('.dropdown.open');
            dropdowns.forEach((elem) => {
                elem.classList.remove('open');
            });
        });
    }

    return {
        init
    }

})();

export default dropdown;
